<template>
  <div
    v-if="menu"
    style="margin: 0px 0px 0px 5px;">
    <div class="item-list">
      <div
        class="item-list-item"
        v-for="item in items"
        :key="item.key + genRandomId()"
        v-bind:class="{ 'item-line-through' : getStationItemState(item.key)[currentStateKey] === 'done' }"
        @click="toggleItemState(item.key)">
        <!-- 主餐名稱 -->
        <span class="item-list-item__main">
          - {{ item.title }} {{ item.number === undefined ?  '' : `* ${item.number}` }}
        </span>
        <!-- 主餐 option list -->
        <div class="item-list-item__option-list">
          <span
            v-for="option in item.options"
            :key="option.id + genRandomId()"
            class="item-list-item__option">
              {{ option.title }} {{ option.number === undefined ?  '' : `* ${option.number}` }}
          </span>
        </div>
      </div>
    </div>
    <div class="item-list__special-request" v-if="specialRequests">
      <div class="item-list__special-request-title">
        備註: {{ specialRequests }}
      </div>
      <div v-if="displayAfter" class="item-list__special-request-icon" @click.stop="showFullSpecialRequest">
        <font-awesome-icon icon="arrows-alt"  />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import storeMenuHelp from '@Util/menu/storeMenuHelp'
import { storeClient } from '@/service/apiClients'
import shortid from 'shortid'
import managerWorkStation from '@Manager/storeManager/workStation'
export default {
  name: 'order-list-item-main',
  dependencies: ['CartElementBuilder'],
  mixins: [managerWorkStation],
  data: () => ({ displayAfter: true }),
  computed: {
    ...mapGetters(['storeId']),
    ...mapState('itemstateModule', ['itemGather']),
    ...mapState(['settings']),
    ...mapGetters('itemstateModule', ['getStationItemState']),
    items () {
      return storeMenuHelp.orderItemToWorkStationFormat(this.workStationMap, this.filterConfig.id, { id: this.orderId }, this.itemObj, this.menu)
    },
    currentStateKey () {
      return `${this.filterConfig.id}-kitchen_state`
    }
  },
  created () {
    // 檢查有沒有這個 menu 的資料
    this.downloadMenu({ version: this.menuVersion, variation: this.menuVariation })
  },
  updated () {
    this.downloadMenu({ version: this.menuVersion, variation: this.menuVariation })
  },
  props: {
    orderId: Number,
    itemObj: Object,
    specialRequests: String,
    menu: Object,
    menuVersion: Number,
    menuVariation: String,
    filterConfig: Object
  },
  methods: {
    ...mapActions('menuModule', ['downloadMenu']),
    ...mapActions('itemstateModule', ['syncStoreTempState']),
    showFullSpecialRequest () {
      this.$f7router.navigate(`/stores/${this.storeId}/order-details/${this.orderId}/items/${this.itemObj.instanceId}/special-requests-popup`)
    },
    genRandomId () {
      return shortid.generate()
    },
    async toggleItemState (key) { // 設定 item 做完
      // if (this.filterConfig.id !== 'kitchen') return // 如果不是廚房站點，則不執行
      const value = this.getStationItemState(key)[this.currentStateKey] === 'done' ? 'no' : 'done'
      try {
        await storeClient.put(`/stores/${this.storeId}/itemTempState`, {
          itemId: key,
          key: this.currentStateKey,
          value
        })
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style scoped>
  .item-list {
    display: flex;
    flex-wrap: wrap;
    margin-left: 16px;
    /* flex-direction: column; */
  }

  .item-list-item {
    display: flex;
    /* flex-direction: column; */
    flex-wrap: wrap;
    /* margin-right: 0.5rem; */
    /* margin-left: 0.5rem; */
  }

  .item-list-item:first-child {
    margin-left: -16px;
  }

  .item-list-item__option-list {
    display: flex;
    flex-wrap: wrap;
    margin-left: 0.5rem;
  }

  .item-list-item__option {
    margin-right: 0.5rem;
  }

  .item-list__special-request {
    display: flex;
    color: red;
    overflow-x: hidden;
    width: 100%;
    padding: 0px 8px;
    box-sizing: border-box;
  }

  .item-list__special-request-title {
    overflow : hidden;
    text-overflow : ellipsis;
    white-space : nowrap;
  }

  .item-line-through {
    text-decoration: line-through #888888 double;
  }
  .item-list__special-request-icon {
    margin-left: auto;
    width: 20px;
  }
</style>
